import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  login(data: any) {
    return this.http.post(environment.apiUrl + '/auth/login', data);
  }

  normalizeRoleSpacing(role: unknown): string {
    return String(role || '')
      .trim()
      .replace(/\s+/g, ' ');
  }

  // Space/case-insensitive comparison so "SUPER ADMIN" and "SUPERADMIN" are treated as the same role.
  normalizeRoleForCompare(role: unknown): string {
    return String(role || '')
      .trim()
      .replace(/\s+/g, '')
      .toUpperCase();
  }

  // STORE USER DATA
  storeUserData(data: any) {
    const user = data?.user || {};

    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    sessionStorage.setItem('token', String(data?.access_token || '').trim());
    sessionStorage.setItem('user', JSON.stringify(user));
  }

  // GET TOKEN
  getToken(): string | null {
    return sessionStorage.getItem('token');
  }

  // GET USER
  getUser() {
    const user = sessionStorage.getItem('user');
    if (!user) {
      return null;
    }

    try {
      const parsed = JSON.parse(user);
      if (!parsed || typeof parsed !== 'object') {
        return null;
      }

      return {
        ...parsed,
        role: this.normalizeRoleSpacing(parsed.role),
      };
    } catch {
      this.clearUserData();
      return null;
    }
  }

  // CHECK LOGIN
  isLoggedIn(): boolean {
    const token = this.getToken();
    const user = this.getUser();
    return !!token && !!user && !!this.normalizeRoleSpacing(user.role);
  }

  // CLEAR USER DATA
  clearUserData() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
  }

  // LOGOUT
  logout() {
    this.clearUserData();
    this.router.navigate(['/login']);
  }
}